import { render, staticRenderFns } from "./ConnectionDogane.vue?vue&type=template&id=bfd96d62&scoped=true"
import script from "./ConnectionDogane.vue?vue&type=script&lang=ts"
export * from "./ConnectionDogane.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionDogane.vue?vue&type=style&index=0&id=bfd96d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd96d62",
  null
  
)

export default component.exports